__turbopack_context__.v({
  "desktopBuySectionInfo": "IxdvkW_desktopBuySectionInfo",
  "mobileBuySectionInfo": "IxdvkW_mobileBuySectionInfo",
});
